import { render } from "./MyProjectNumCard.vue?vue&type=template&id=4e8b87d2"
import script from "./MyProjectNumCard.vue?vue&type=script&lang=js"
export * from "./MyProjectNumCard.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__